<template>
  <div class="TecAndSer">
    <div class="main">
      <p class="title">技术与服务精炼</p>
      <p class="sub_title">基于数据分析的精准用户推广服务方案</p>

      <p class="content" v-for="item,index in contents" v-html="item"></p>

      <ul class="items">
        <li class="item" v-for="item,index in items">
          <img :src="item.imgUrl" />
          <p class="title">{{item.title}}</p>
          <p class="remark">{{item.remark}}</p>
        </li>
      </ul>

    </div>
  </div>
</template>

<script>
export default {
  name: 'TecAndSer',
  data () {
    return {
      items: [
        {imgUrl: require("@/assets/imgs/img-home-service-01.png"),title:"用户画像",remark:"让您了解TA"},
        {imgUrl: require("@/assets/imgs/img-home-service-02.png"),title:"圈定人群",remark:"让您找到TA"},
        {imgUrl: require("@/assets/imgs/img-home-service-03.png"),title:"用户推送",remark:"让您影响TA"},
        {imgUrl: require("@/assets/imgs/img-home-service-04.png"),title:"效果优化",remark:"让您影响更多的TA"},
      ],
      contents:
        ["公司以spark大数据生态组件作为核心处理技术，拥有对海量数据开展规整处理、刻画出用户画像体系并不断迭代、丰富受众标签描述的专业技术能力，能够利用业务经营过程中正、负样本数据，通过TGI(Target Group Index)对受众行为偏好进行计算分析，选出符合客户需求的优质受众，为客户开展“千人千面”的精准营销策略奠定坚实的技术基础。",
      ],
    }
  },
  mounted() {
    var screenHeight =  document.documentElement.clientHeight
    setTimeout(function() {
      window.onscroll = function() {
        var bool = $(window).scrollTop()+$(window).height()==$(document).height();
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        let fontSize = getComputedStyle(window.document.documentElement)['font-size'];

        var lis = $('.TecAndSer .items li')
        for(var i =0;i<lis.length;i++) {
          var offsetTop = $(lis[i]).offset().top
          if(offsetTop - scrollTop - screenHeight < 0 && !bool && !$(lis[i]).hasClass('active')) {
            $(lis[i]).addClass('active')
          }
        }
      }
    },100)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" type="text/scss">
  @import '../../assets/css/animation.css';
  .TecAndSer {
    width: 100%;
    height: 770px;
    display: inline-block;
    /*background:rgba(244,244,244,1);*/
    background: #fff;

    .main {
      width: 1200px;
      margin: 0 auto;
      p {
        margin: 0;
      }
      >.title {
        height:50px;
        font-size:40px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        text-align: center;
        margin-top: 59px;
      }
      >.sub_title {
        height:40px;
        font-size:30px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        text-align: center;
        margin: 29px 0 70px;
      }

      .content {
        font-size:18px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        line-height:33px;
        margin-bottom: 50px;
      }

      .items {
        margin: 0;
        display: inline-block;
        padding-left: 84px;

        .item {
          width: 183px;
          list-style: none;
          float: left;
          margin-right: 100px;
          p{
            text-align: center;
          }
          &.active>img{
            -moz-animation: RotateY 0.5s linear forwards;
            -ms-animation: RotateY 0.5s linear forwards;
            -webkit-animation: RotateY 0.5s linear forwards;
            -o-animation: RotateY 0.5s linear forwards;
            animation: RotateY 0.5s linear forwards;
          }
          >img {
            width: 183px;
            height: 183px;
            border-radius: 8px;
            margin: 0 auto;
            display: block;
            opacity: 0;
            transform:RotateY(90deg);
            -ms-transform:RotateY(90deg); 	/* IE 9 */
            -moz-transform:RotateY(90deg); 	/* Firefox */
            -webkit-transform:RotateY(90deg); /* Safari 和 Chrome */
            -o-transform:RotateY(90deg); 	/* Opera */
          }
          >.title {
            height:30px;
            font-size:24px;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(0,0,0,1);
            margin-top: 20px;
          }
          >.remark {
            height:25px;
            font-size:18px;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(136,136,136,1);
            margin: 12px 0;
          }
        }
        .item:last-child{
          margin-right: 0;
        }
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/TecAndSer.vue